import { render, staticRenderFns } from "./Arvore.vue?vue&type=template&id=60d6decc"
import script from "./Arvore.vue?vue&type=script&lang=js"
export * from "./Arvore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports